var _style, _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAmericanExpress = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 134 100",
    style: {
      enableBackground: "new 0 0 134 100"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:url(#SVGID_3_);}\n\t.st2{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M8.4,100h117.1c4.4,0,8-3.6,8-8V68.3v-35v-9.9V8c0-4.4-3.6-8-8-8H76.7H52.5H8.4c-4.4,0-8,3.6-8,8v6.1v19.2 v35V92C0.4,96.4,4,100,8.4,100z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 73.1658,
    cy: 220.4139,
    r: 130.8961,
    gradientTransform: "matrix(0.9605 0 0 -0.9626 -46.9476 216.9609)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DD5F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0711,
    style: {
      stopColor: "#98D3F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1575,
    style: {
      stopColor: "#89CEF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2516,
    style: {
      stopColor: "#70C6EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3514,
    style: {
      stopColor: "#4EBBEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4546,
    style: {
      stopColor: "#23ADE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#0DA6E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E77BC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.7-18.7h-134V116h134V71.5c0.5-0.8,0.8-1.8,0.8-3c0-1.4-0.3-2.2-0.8-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.6,39.6l-2.6-6.3l-2.6,6.3 M68.5,37.1c-0.5,0.3-1.1,0.3-1.9,0.3h-4.6v-3.5h4.6c0.7,0,1.3,0,1.8,0.3 c0.5,0.2,0.8,0.7,0.8,1.4C69.3,36.2,69,36.8,68.5,37.1z M101.3,39.6l-2.6-6.3L96,39.6H101.3z M40.3,46.4h-3.9l0-12.4l-5.5,12.4 h-3.3L22.1,34v12.4h-7.7L13,42.9H5.1l-1.5,3.5h-4.1l6.8-15.8h5.6l6.4,14.9V30.6h6.2l4.9,10.7L34,30.6h6.3L40.3,46.4L40.3,46.4z  M55.7,46.4H43.1V30.6h12.6v3.3h-8.8v2.8h8.6V40h-8.6v3.2h8.8V46.4z M73.5,34.8c0,2.5-1.7,3.8-2.7,4.2c0.8,0.3,1.5,0.9,1.9,1.3 c0.5,0.8,0.6,1.5,0.6,2.9v3.1h-3.8l0-2c0-1,0.1-2.3-0.6-3.1c-0.6-0.6-1.4-0.7-2.8-0.7h-4.1v5.7h-3.8V30.6H67 c1.9,0,3.3,0.1,4.6,0.8C72.8,32.1,73.5,33.1,73.5,34.8z M79.5,46.4h-3.9V30.6h3.9V46.4z M124.2,46.4h-5.3l-7.2-11.9v11.9H104 l-1.5-3.5h-7.8l-1.4,3.5h-4.4c-1.8,0-4.2-0.4-5.5-1.7c-1.3-1.3-2-3.2-2-6c0-2.3,0.4-4.5,2-6.2c1.2-1.3,3.1-1.8,5.7-1.8h3.7V34 h-3.6c-1.4,0-2.2,0.2-2.9,0.9c-0.6,0.7-1.1,1.9-1.1,3.6c0,1.7,0.3,2.9,1,3.7c0.6,0.6,1.6,0.8,2.6,0.8h1.7l5.3-12.4h5.7l6.4,14.9 V30.6h5.7l6.6,11v-11h3.9V46.4L124.2,46.4z M-0.5,49.5H6L7.4,46h3.3l1.5,3.5h12.7v-2.7l1.1,2.7h6.6l1.1-2.7v2.7h31.5l0-5.8h0.6 c0.4,0,0.6,0.1,0.6,0.8v5h16.3v-1.3c1.3,0.7,3.4,1.3,6.1,1.3h6.9l1.5-3.5h3.3l1.4,3.5H115v-3.3l2,3.3h10.6v-22h-10.5v2.6l-1.5-2.6 h-10.8v2.6l-1.3-2.6H89c-2.4,0-4.6,0.3-6.3,1.3v-1.3h-10v1.3c-1.1-1-2.6-1.3-4.3-1.3H31.7l-2.5,5.7l-2.5-5.7H15.2v2.6L14,27.5H4.1 l-4.6,10.5L-0.5,49.5L-0.5,49.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.8,61.1h-6.9c-0.7,0-1.1,0-1.5,0.3c-0.4,0.3-0.6,0.6-0.6,1.1c0,0.6,0.3,1,0.8,1.2 c0.4,0.1,0.8,0.2,1.5,0.2l2,0.1c2.1,0.1,3.4,0.4,4.3,1.3c0.2,0.1,0.2,0.3,0.4,0.4 M133.8,71.5c-0.9,1.3-2.7,2-5.1,2h-7.3v-3.4h7.3 c0.7,0,1.2-0.1,1.5-0.4c0.3-0.2,0.4-0.6,0.4-1c0-0.5-0.2-0.8-0.5-1c-0.3-0.2-0.7-0.4-1.3-0.4c-3.5-0.1-8,0.1-8-4.9 c0-2.3,1.5-4.7,5.4-4.7h7.5v-3.1h-7c-2.1,0-3.6,0.5-4.7,1.3v-1.3h-10.3c-1.7,0-3.6,0.4-4.5,1.3v-1.3H88.8v1.3 c-1.5-1.1-3.9-1.3-5.1-1.3H71.6v1.3c-1.2-1.1-3.7-1.3-5.3-1.3H52.6L49.5,58l-2.9-3.4H26.2v22h20l3.2-3.4l3,3.4l12.3,0v-5.2H66 c1.6,0,3.6,0,5.3-0.8v5.9h10.1v-5.7h0.5c0.6,0,0.7,0,0.7,0.7v5.1h30.8c2,0,4-0.5,5.1-1.4v1.4h9.8c2,0,4-0.3,5.5-1V71.5L133.8,71.5 z M118.8,65.2c0.7,0.8,1.1,1.7,1.1,3.3c0,3.4-2.1,5-5.9,5h-7.4v-3.4h7.3c0.7,0,1.2-0.1,1.5-0.4c0.3-0.2,0.4-0.6,0.4-1 c0-0.5-0.2-0.8-0.5-1c-0.3-0.2-0.7-0.4-1.3-0.4c-3.5-0.1-7.9,0.1-7.9-4.9c0-2.3,1.4-4.7,5.4-4.7h7.6v3.4h-6.9 c-0.7,0-1.1,0-1.5,0.3c-0.4,0.3-0.6,0.6-0.6,1.1c0,0.6,0.4,1,0.8,1.2c0.4,0.1,0.8,0.2,1.5,0.2l2,0.1 C116.5,64,117.9,64.4,118.8,65.2z M84.7,64.3c-0.5,0.3-1.1,0.3-1.9,0.3h-4.6V61h4.6c0.7,0,1.3,0,1.8,0.3c0.5,0.3,0.8,0.7,0.8,1.4 C85.5,63.4,85.2,64,84.7,64.3z M87,66.2c0.8,0.3,1.5,0.9,1.8,1.3c0.5,0.8,0.6,1.5,0.6,2.9v3.1h-3.8v-2c0-0.9,0.1-2.4-0.6-3.1 c-0.6-0.6-1.4-0.7-2.8-0.7h-4v5.8h-3.8V57.8h8.7c1.9,0,3.3,0.1,4.5,0.7c1.2,0.7,1.9,1.7,1.9,3.5C89.7,64.5,88,65.8,87,66.2z  M91.7,57.8h12.6V61h-8.8v2.9h8.6v3.2h-8.6v3.1l8.8,0v3.3H91.7V57.8z M66.3,65.1h-4.9v-4h4.9c1.4,0,2.3,0.6,2.3,1.9 C68.6,64.3,67.7,65.1,66.3,65.1z M57.7,72.1l-5.8-6.4l5.8-6.2V72.1z M42.7,70.3h-9.3v-3.1h8.3v-3.2h-8.3V61h9.5l4.1,4.6L42.7,70.3 z M72.7,63c0,4.4-3.3,5.3-6.6,5.3h-4.7v5.3h-7.3l-4.6-5.2l-4.8,5.2H29.6V57.8h15.2l4.6,5.2l4.8-5.2h12.1 C69.3,57.8,72.7,58.6,72.7,63z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAmericanExpress);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/american-express.c23478a94844dfa5db680e47b04ec535.svg";